module.exports = __webpack_public_path__ + "img/linkedin.b2469d03.svg";